import Enum from "../../../../../../enums/Enum";

const NextAppointmentInEnum = new Enum({
    Days: {name: "Days"},
    Weeks: {name: "Weeks"},
    Months: {name: "Months"},
    Years: {name: "Years"}
});

export default NextAppointmentInEnum;